export default __webpack_public_path__ + "standard_poster.png";